export const FETCH_DESTINATION_DETAIL_REQUESTED = 'FETCH_DESTINATION_DETAIL_REQUESTED';
export const FETCH_DESTINATION_DETAIL_SUCCEEDED = 'FETCH_DESTINATION_DETAIL_SUCCEEDED';
export const FETCH_DESTINATION_TYPE_SUCCEEDED_WITHOUR_PREFILL = 'FETCH_DESTINATION_TYPE_SUCCEEDED_WITHOUR_PREFILL';
export const UPDATE_DESTINATION_REQUESTED = 'UPDATE_DESTINATION_REQUESTED';
export const UPDATE_DESTINATION_SUCCEEDED = 'UPDATE_DESTINATION_SUCCEEDED';
export const SELECT_DESTINATION_TYPE = 'SELECT_DESTINATION_TYPE';
export const FETCH_ALL_DESTINATION_TYPE_SUCCEEDED = 'FETCH_ALL_DESTINATION_TYPE_SUCCEEDED';

